module.exports = __webpack_public_path__ + "img/wax-logo-white.8739b7a4.svg";